import axios from './axios';

export const notificationRead = (id) => {
  return axios.post(`/api/notifications/${id}/read`);
};
export const notificationUnread = (id) => {
  return axios.post(`/api/notifications/${id}/unread`);
};
